import { render, staticRenderFns } from "./scb.vue?vue&type=template&id=4955a0b4&scoped=true"
import script from "./scb.vue?vue&type=script&lang=js"
export * from "./scb.vue?vue&type=script&lang=js"
import style0 from "./scb.vue?vue&type=style&index=0&id=4955a0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955a0b4",
  null
  
)

export default component.exports